import { styled } from '@acko-tech/building-blocks.ui.common';

export const Container = styled.div`
  width: 100%;
  max-width: 480px;
  margin: auto;
`;

export const BoldText = styled.div`
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.375rem;
  margin: 24px 0 10px 0;
  padding: 0 44px;
`;

export const MediumText = styled.div`
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.25rem;
`;

export const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${(props) => props?.height || '40vh'};
  text-align: center;
`;

export const ButtonContainer = styled.div`
  width: inherit;
  position: absolute;
  bottom: 0;
  padding: 20px;
  max-width: inherit;
`;

export const ExtraMessage = styled.div`
  font-weight: 200;
  font-size: 1rem;
  line-height: 1.25rem;
  word-break: break-all;
  padding: 20px;
`;
